import BaseApi from "./BaseApi";

const baseUrl = 'api/SupportingMaterial/';

class SupportingMaterialService {
    static getBanner(): Promise<any> {
        return BaseApi.get(`${baseUrl}Banner`);
    }
    static setBanner(formData:FormData): Promise<any> {
        return BaseApi.post(`${baseUrl}Banner`, formData, {
            headers: {
            "Content-Type": "multipart/form-data"
            }
        });
    }
    static getCategory(): Promise<any> {
        return BaseApi.get(`${baseUrl}Category`);
    }
    static getCategorySubAndItemsById(id:number): Promise<any> {
        return BaseApi.get(`${baseUrl}CategorySubAndItemsById/${id}`);
    }
    static setCategory(category:any): Promise<any> {
        return BaseApi.post(`${baseUrl}Category`, category);
    }
    static setSubCategory(subCategory:any): Promise<any> {
        return BaseApi.post(`${baseUrl}SubCategory`, subCategory);
    }
    static deleteCategory(id:number): Promise<any> {
        return BaseApi.delete(`${baseUrl}Category/${id}`);
    }
    static updateCategory(cat:any): Promise<any> {
        return BaseApi.put(`${baseUrl}Category`, cat);
    }
    static updateCategoryOrder(cat:any): Promise<any> {
        return BaseApi.put(`${baseUrl}CategoryOrdem`, cat);
    }
    static updateSubCategory(subCategory:any): Promise<any> {
        return BaseApi.put(`${baseUrl}SubCategory`, subCategory);
    }
    static updateSubCategoryOrdem(subCategory:any): Promise<any> {
        return BaseApi.put(`${baseUrl}SubCategoryOrdem`, subCategory);
    }
    static updateItem(item:any): Promise<any> {
        return BaseApi.put(`${baseUrl}Item`, item);
    }
    static updateItemOrdem(item:any): Promise<any> {
        return BaseApi.put(`${baseUrl}ItemOrdem`, item);
    }
    static deleteSubCategory(id: number) {
        return BaseApi.delete(`${baseUrl}SubCategory/${id}`);
    }
    static deleteItem(id: number) {
        return BaseApi.delete(`${baseUrl}Item/${id}`);
    }
    static insertItem(formData:FormData): Promise<any> {
        return BaseApi.post(`${baseUrl}Item`, formData, {
            headers: {
            "Content-Type": "multipart/form-data"
            }
        });
    }
    static updateItemForm(formData:FormData): Promise<any> {
        return BaseApi.put(`${baseUrl}ItemForm`, formData, {
            headers: {
            "Content-Type": "multipart/form-data"
            }
        });
    }
}

export default SupportingMaterialService;